(function () {
    // 注册组件
    SR.component.extend('foldContent', foldContent);

    function foldContent(answerDomId) {
        var $contentWrap = $('#' + answerDomId).find('.J_fold');
        var $content = $contentWrap.find('.tts-content');
        var $foldToggleBtn = $('<div class="fold-toggle J_foldToggle">展开</div>');
        var spHeight = parseInt($content.css('margin-top'));
        var contentHeight = $content.height() + spHeight;
        var maxH = 150;
        var foldH = 100 + spHeight;

        if (contentHeight > maxH) {
            $contentWrap.addClass('fold');
            foldH = $contentWrap.height();
            $contentWrap.height(foldH);
            $contentWrap.css('overflow', 'hidden');
            $contentWrap.after($foldToggleBtn);

            $foldToggleBtn.on('click', function() {
                var $me = $(this);
                var $foldContent = $me.prev('.J_fold');
                foldToggleHandel($foldContent, $me);
            });

            $contentWrap.on('click', function() {
                var $me = $(this);
                var $toggleBtn = $me.next('.J_foldToggle');
                foldToggleHandel($me, $toggleBtn);
            });

            function foldToggleHandel($foldContent, $toggleBtn) {
                if ($toggleBtn.hasClass('has-fold')) {
                    $toggleBtn.removeClass('has-fold').text('展开');
                    $foldContent.animate({
                        height: foldH
                    }, 200, function() {
                        $foldContent.addClass('fold');
                    });
                } else {
                    $toggleBtn.addClass('has-fold').text('收起');
                    $foldContent.removeClass('fold').animate({
                        height: contentHeight
                    }, 200);
                }
            }
        }
    }
}());